import React from "react"
import { DadosBancariosSubcontaContextProvider } from "./context/DadosBancariosSubcontaContextProvider"
import { DadosBancariosSubconta } from "./DadosBancariosSubconta"

export function Index() {
    return (
        <DadosBancariosSubcontaContextProvider>
            <DadosBancariosSubconta />
        </DadosBancariosSubcontaContextProvider>
    )
}
